/**
 * Blocks the browser context menu on all images and videos site-wide, so the
 * "Save image as…" / "Download video" options are never shown. Uses a single
 * capture-phase listener on document, so it also covers media rendered later
 * (CMS blocks, lightboxes, lazy-hydrated components).
 *
 * Dragging images out of the page is disabled too, since drag-and-drop to the
 * desktop is the other one-gesture way to save an image.
 *
 * Note: this is a deterrent only — media inside cross-origin iframes (e.g.
 * YouTube embeds) can't be intercepted, and files remain reachable via
 * devtools or direct URL.
 */
export default defineNuxtPlugin(() => {
  const isMedia = (target: EventTarget | null): boolean =>
    target instanceof Element && !!target.closest('img, picture, video')

  document.addEventListener(
    'contextmenu',
    (e) => {
      if (isMedia(e.target)) e.preventDefault()
    },
    { capture: true }
  )

  document.addEventListener(
    'dragstart',
    (e) => {
      if (isMedia(e.target)) e.preventDefault()
    },
    { capture: true }
  )
})
